import { createSelector } from 'reselect'
import compose from 'ramda/es/compose'
import filter from 'ramda/es/filter'
import omit from 'ramda/es/omit'
import toPairs from 'ramda/es/toPairs'
import map from 'ramda/es/map'
import fromPairs from 'ramda/es/fromPairs'

import l10n from './l10n'
const { estateFilterLabels } = l10n

export const sFilterChips = createSelector(
  (state, manualFilters) =>
    manualFilters ? manualFilters : state.estateOverviewFilters,
  filters => {
    if (!filters || !estateFilterLabels) {
      return {}
    }

    const toOmitByVermarktungart = {
      kauf: ['mietpreis'],
      miete: ['kaufpreis'],
    }

    const toOmit = [
      ...['id', 'vermarktungsart', 'order', 'orderby'],
      filters.vermarktungsart in toOmitByVermarktungart
        ? toOmitByVermarktungart[filters.vermarktungsart]
        : [],
    ]

    return compose(
      fromPairs,
      filter(([, v]) => !!v),
      map(([k, v]) => {
        if (k === 'location' && !!v) {
          return [k, v.location]
        }

        if (!(k in estateFilterLabels) || !v) {
          return [k, v]
        }

        if (['perimeter'].includes(k)) {
          return [
            k,
            `${v}${
              'suffix' in estateFilterLabels[k]
                ? ' ' + estateFilterLabels[k].suffix
                : ''
            } ${estateFilterLabels[k].label}`,
          ]
        }

        if (['zimmer', 'kaufpreis', 'mietpreis', 'wohnflaeche'].includes(k)) {
          if (v.from == 0 && v.to == 0) {
            return [k, '']
          }
        }

        if (['zimmer'].includes(k)) {
          return [
            k,
            `${
              v.from && !v.to
                ? estateFilterLabels[k].prefixFrom + ' '
                : !v.from && v.to
                ? estateFilterLabels[k].prefixTo + ' '
                : ''
            }${v.from ? v.from : ''}${
              v.from && v.to ? ' - ' + v.to : !v.from && v.to ? v.to : ''
            } ${estateFilterLabels[k].label}`,
          ]
        }

        if (['kaufpreis', 'mietpreis'].includes(k)) {
          return [
            k,
            `${
              !v.from && v.to
                ? estateFilterLabels[k].prefix + ' '
                : !v.from && v.to
                ? estateFilterLabels[k].prefix + ' '
                : ''
            }${v.from ? v.from : ''}${
              v.from && v.to ? ' - ' + v.to : !v.from && v.to ? v.to : ''
            } ${estateFilterLabels[k].suffix}`,
          ]
        }

        if (['wohnflaeche'].includes(k)) {
          return [
            k,
            `${
              v.from && !v.to
                ? estateFilterLabels[k].prefix + ' '
                : !v.from && v.to
                ? estateFilterLabels[k].prefix + ' '
                : ''
            }${v.from ? v.from : ''}${
              v.from && v.to ? ' - ' + v.to : !v.from && v.to ? v.to : ''
            } ${estateFilterLabels[k].suffix}`,
          ]
        }

        if (['mietpreis', 'kaufpreis'].includes(k)) {
          v = v.toLocaleString('de')
        }

        return [
          k,
          `${
            'prefix' in estateFilterLabels[k]
              ? estateFilterLabels[k].prefix + ' '
              : ''
          }${v}${
            'suffix' in estateFilterLabels[k]
              ? ' ' + estateFilterLabels[k].suffix
              : ''
          }`,
        ]
      }),
      toPairs,
      omit(toOmit)
    )(filters)
  }
)
